import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RxFormControlErrorsDirective } from '@nrwl/rx-form-errors';
import { TextareaAutosizeDirective } from '../shared/textarea-autosize-directive';
import { PasteStripDirective } from '../shared/paste-strip-directive';

@Component({
  selector: 'fb-add-medical-note-dialog',
  imports: [
    ReactiveFormsModule,
    RxFormControlErrorsDirective,
    TextareaAutosizeDirective,
    PasteStripDirective,
  ],
  templateUrl: './add-medical-note-dialog.html',
  styleUrl: './add-medical-note-dialog.scss',
})
export class AddMedicalNoteDialog implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  protected payload = '';

  protected readonly form = this.fb.group({ note: ['', Validators.required] });

  public ngOnInit(): void {
    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ note }) => (this.payload = note));
  }

  public isValid(): boolean {
    return this.form.valid;
  }

  public validate(): void {
    this.form.markAllAsTouched();
  }
}
